const fixPos = () => {
    const viewportWidth = window.innerWidth;
    document.querySelectorAll('.navigation-menu .navigation-item.has-sub-menu').forEach(item => {
        const dropdown = item.querySelector('.mega-menu');
        if (!dropdown) return;

        const rect = dropdown.getBoundingClientRect();

        let shiftX = 0;
//console.log(viewportWidth, rect.right + 200 > viewportWidth);
        /*if (rect.left < 0) {
           // shiftX = -rect.left + 16;
        } else*/
        if (rect.right + 200 > viewportWidth) {
            shiftX = viewportWidth - rect.right - 200;
        }
        if (shiftX !== 0) {
            //console.log('przesuniecie', shiftX);
            dropdown.style.transform = `translateX(${shiftX}px)`;
        }
    })
}
window.addEventListener('DOMContentLoaded', () => {
    fixPos()
});

window.addEventListener('resize', () => {
    fixPos()
});